import * as React from 'react';

import { Hero } from '@bumble/ui-kit';
import about from 'components/lexemes/page-about';

export const AboutHeroBlockContainer: React.FC = () => {
  return (
    <Hero
      variant="full-width-image"
      backgroundImageSrc="/project-love/assets/about-hero-1.jpg"
      backgroundImageAlt={about.lxPageAboutHeroAlt}
      textColor="inverse"
      ctaBox={{
        title: about.lxPageAboutHeroTitle,
        description: about.lxPageAboutHeroDescription,
      }}
    />
  );
};
